import { getAssetsUrl } from "../../../shared/pipes/assets-url/assets-url"

export class HistoricoVentas {
    Dia: number
    Mes: string
    Year: number
    Month: number
    Semana: number
    Monto: number
    ID_Programa: number
}

export interface IResultComprasMes {
    message: string;
    status: string;
    success: boolean;
    MontoVentasMes: IMontoVentasMes[]
    ConfigCompras: IConfigCompras
}

export interface IResultComprasDiasSem {
    success: boolean
    status: string
    message: string
    MontoVentasDia: IMontoVentasDia[]
    MontoVentasSemana: IMontoVentasSemana[]
}

export interface IResultComprasTickets {
    success: boolean
    status: string
    message: string
    TicketsPreventa: ITicketsPreventa[]
}

export interface IMontoVentasDia extends ITicketsVentasMontos {
    ID_ProgramaVenta?: number;
    Monto?: number;
    Etiqueta?: string;
}
export interface ITicketsPreventa extends ITicketsVentasMontos {
    TipoRuta?: number;
}

export interface ITicketsVentasMontos {
    ID_Bodega: number;
    NUD: number;
    Fecha?: string;
    FechaFormat?: string;
    Mes_Selecionado: string;
    Anio: number;
    Mes: number;
    Dia: number;
    Month: string;
    SemanaMes: number;
    MesActual?: boolean;
    Ticket: string;
    TicketVisto?: boolean;
    IconPreventa?: string;
}

export interface IMontoVentasSemana {
    Month?: string
    Mes?: number
    Anio?: number
    SemanaMes?: string
    Monto?: number
    Mes_Selecionado?: string
    MesActual?: boolean;
}

export interface IMontoVentasMes {
    Historico?: string
    Month?: string
    Mes?: number
    Anio?: number
    Monto?: number
    Mes_Selecionado?: string
    InicioMes?: string
    MesActual?: boolean
    MesPasado?: boolean
    IsTicketEntrega?: boolean
    IsTicketPreventa?: boolean
}

export interface IConfigCompras {
    Config_Entrega?: IConfigEntrega
    Config_Preventa?: IConfigPreventa
    Config_Compras?: IConfigComprasIcons
    IsTicketEntrega?: boolean
    IsTicketPreventa?: boolean
}

export interface IConfigComprasIcons {
    download_blue: string
    download_blue_demon: string
    view_blue: string
    ticket_preventa_white: string
    entrega_white: string
    entrega_gray: string
    etiqueta_ultimo: string
    sin_info: string
    mes_historico: number
    error_obtener_meses: string
    error_obtener_dias_semanas: string
    error_obtener_preventa: string
    download: IDownload
    titles_tabs: ITabsCompras[]
}

interface IDownload {
    ios: boolean,
    android: boolean
}

interface ITabsCompras {
    titulo: string
    icono: string
}

export interface IDictionary {
    [id: string]: string
}

export interface IConfigEntrega {
    color: string
    icono: string
    label: string
    titulo: string
    IconEntregaUltimo?: string
    IconEntrega?: string
}

export interface IConfigPreventa {
    copy: Copy
    rutas: Rutas
    rutas_icons_list: IDictionary
}

interface Copy {
    icon: string
    textHasNoTickets: string
    textHasTickets: string
    titulo: string
}

interface Rutas {
    [id: string]: IRutasConfig
}

interface IRutasConfig {
    color: string
    desc: string
    icono: string
}


export const DConfigEntrega: IConfigEntrega = {
    color: 'tpplus',
    icono: getAssetsUrl('imagenes/compras/ruta-truck-tradicional.svg'),
    label: '',
    titulo: 'Ticket de Entrega',
    IconEntregaUltimo: getAssetsUrl('iconos/ticket-compra-ultimo.svg'),
    IconEntrega: getAssetsUrl('iconos/ticket-compra.svg')
}

export const DConfigPreventa: IConfigPreventa = {
    copy: {
        icon: getAssetsUrl('imagenes/compras/ticket-preventa-icon.svg'),
        textHasNoTickets: 'Sin tickets de preventa',
        textHasTickets: 'Consulta tu último ticket de <b>preventa</b>',
        titulo: 'Ticket de Preventa'
    },
    rutas: {
        1: {
            color: 'tpdesarrollo',
            desc: 'ruta_desarrollo',
            icono: getAssetsUrl('imagenes/compras/ticket-preventa-desarrollo.svg')
        },
        2: {
            color: 'tpteleventa',
            desc: 'ruta_televenta',
            icono: getAssetsUrl('imagenes/compras/ticket-preventa-televenta.svg')
        },
        3: {
            color: 'tpplus',
            desc: 'ruta_resto_rutas',
            icono: getAssetsUrl('imagenes/compras/ticket-preventa-resto-rutas.svg')
        },
        4: {
            color: 'tptradicional',
            desc: 'ruta_otras_rutas',
            icono: getAssetsUrl('imagenes/compras/ticket-preventa-otros.svg')
        }
    },
    rutas_icons_list: {
        ruta_1: getAssetsUrl('iconos/icon-ticket-preventa-desarrollo.svg'),
        ruta_2: getAssetsUrl('iconos/icon-ticket-preventa-televenta.svg'),
        ruta_3: getAssetsUrl('iconos/icon-ticket-preventa-resto-rutas.svg'),
        ruta_4: getAssetsUrl('iconos/icon-ticket-preventa-otros.svg')
    }
}

export const DConfigCompras: IConfigComprasIcons = {
    download_blue: getAssetsUrl('iconos/icon-generic-download-blue-2.svg'),
    download_blue_demon: getAssetsUrl('iconos/icon-generic-download-blue-demon.svg'),
    view_blue: getAssetsUrl('iconos/icon-generic-view-blue.svg'),
    ticket_preventa_white: './assets/icon/icon-generic-ticket-preventa-white.svg',
    entrega_white: './assets/icon/icon-generic-entrega-white.svg',
    entrega_gray: getAssetsUrl('iconos/icon-generic-entrega-gray.svg'),
    etiqueta_ultimo: 'Último',
    sin_info: 'Aún no hay información para mostrar',
    mes_historico: 2,
    error_obtener_meses: 'Ocurrió un error al obtener las ventas, intentalo más tarde',
    error_obtener_dias_semanas: 'Ocurrió un error al obtener las ventas del mes, intentalo más tarde',
    error_obtener_preventa: 'Ocurrió un error al obtener los tickets de preventa del mes, intentalo más tarde',
    download: {
        ios: false,
        android: false
    },
    titles_tabs: [
        {
            titulo: 'Entregas',
            icono: getAssetsUrl('iconos/icon-generic-entrega-white.svg')
        },
        {
            titulo: 'Preventa',
            icono: getAssetsUrl('iconos/icon-generic-ticket-preventa-white.svg')
        }
    ]
}
